import { forwardRef } from 'react';

import { Typography, rem } from '@blueprint/ui';

import { colors } from 'themes';

const { black } = colors;

export const Paragraph = forwardRef(({ children, ...rest }, ref) => (
  <Typography ref={ref} as="p" lineHeight={rem(20)} color={black} {...rest}>
    {children}
  </Typography>
));
